import {type TransferApiResponse, toTransfer} from "@/adapters/transfers.adapter";
import {config} from "@/constants/config";
import type {TResponseRequest} from "@/interfaces/http.interface";
import httpRequest from "@/providers/http/request.http";
import {buildQueryUrl} from "@/providers/http/request.instance";
import {type PaginatedResult, normalizePagination} from "@/utils/pagination";

export interface Transfer {
  id: string;
  initiatorUserId: string;
  fromAccountId: string;
  toUserId: string;
  toAccountId: string;
  amountCents: number;
  currency: string;
  feeCents: number;
  netAmountCents: number;
  status: "pending" | "processing" | "completed" | "failed" | "cancelled";
  idempotencyKey: string;
  completedAt: string | null;
  createdAt: string;
  updatedAt: string;
  note?: string;
}

interface TransferFilters {
  page?: number;
  limit?: number;
  status?: string;
  search?: string;
  from?: string;
  to?: string;
}

export type TransferListResult = PaginatedResult<Transfer>;

export const getTransfersService = async (
  filters: TransferFilters = {}
): Promise<TResponseRequest<TransferListResult>> => {
  const raw = await httpRequest.get<TransferApiResponse[]>({
    url: buildQueryUrl(`${config.walletApiUrl}/bo/transfers`, filters as Record<string, unknown>),
  });
  if (!raw.data || !raw.pagination) return {...raw, data: undefined};
  return {...raw, data: {items: raw.data.map(toTransfer), pagination: normalizePagination(raw.pagination)}};
};

export const getTransferByIdService = async (id: string): Promise<TResponseRequest<Transfer>> => {
  const raw = await httpRequest.get<TransferApiResponse>({
    url: `${config.walletApiUrl}/bo/transfers/${encodeURIComponent(id)}`,
  });
  if (!raw.data) return {...raw, data: undefined};
  return {...raw, data: toTransfer(raw.data)};
};
